import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteUser } from "../../hooks/useAccounting";
export const DeleteUserModal = ({ show, handleClose, activityId }) => {
  const [button] = useState(false);
  const [factorId, setFactorId] = useState();
  useEffect(() => {
    setFactorId(activityId);
  }, [activityId]);

  const { mutateAsync: deleteUser } = useDeleteUser();
  const handleDeleteUser = async (id) => {
    await deleteUser(id);
  };

  return (
    <BootstrapModal
      modaltitle="حذف کاربر"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="14px">آیا از حذف این کاربر مطمئن هستید؟</Typogaphy>
        </div>
        <div className="col-12 d-flex justify-content-end">
          <Button
            bgColor="#009ef7"
            color="#fff"
            small="60px"
            style={{ padding: "4px" }}
            onclick={() => {
              handleDeleteUser(factorId);
              handleClose();
            }}
          >
            بله
          </Button>
          <Button
            bgColor="#f1416c"
            color="#fff"
            small="60px"
            style={{ padding: "4px", marginRight: "10px" }}
            onclick={handleClose}
          >
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
